import { el } from './dom';

/** Read-only progress indicator; tasks are completed through gameplay. */
export class TaskCheckbox {
  readonly root = el('span', 'task-checkbox');
  private readonly mark = el('span', 'task-checkbox__mark', '✓');

  constructor() {
    this.root.setAttribute('role', 'img');
    this.mark.setAttribute('aria-hidden', 'true');
    this.root.append(this.mark);
    this.update(false);
  }

  update(complete: boolean, progress = complete ? 1 : 0): void {
    this.root.classList.toggle('task-checkbox--complete', complete);
    this.root.setAttribute('aria-label', complete ? 'Valmis' : 'Kesken');
    this.mark.style.opacity = String(progress);
    this.mark.style.transform = `scale(${0.5 + progress * 0.5}) rotate(-8deg)`;
  }
}
